<ion-card *ngIf="!reportServ.loading; else loader">
  <ion-card-header class="report__header">
    <ion-card-title>
      {{ reportServ.report.title }}
    </ion-card-title>
  </ion-card-header>
  <ion-card-content>
    <div class="content">
      <ion-grid class="no-padding">
        <ion-row>
          <ion-col size="12">
            <h3 class="report__subheader">
              {{ "DESCRIPTION" | translate }}
            </h3>
            <ion-text class="color-black">{{
              reportServ.report.description
            }}</ion-text>
          </ion-col>
        </ion-row>
        <ion-row class="report__images-container">
          <ion-col
            size="6"
            size-md="4"
            *ngFor="let item of reportServ.report.images"
          >
            <div class="horizontal-margin-5">
              <img
                [src]="item.filePath"
                class="report__image"
                (click)="onImagePreview($event, item.filePath)"
              />
            </div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12">
            <div class="report__separator"></div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12">
            <h3 class="report__subheader">
              {{ "REPORT.REPORTING_PERSON" | translate }}
            </h3>
            <app-user-with-avatar
              [user]="reportServ.report.createdBy"
              [grayBackground]="true"
            ></app-user-with-avatar>
          </ion-col>
        </ion-row>
        <ion-row class="ion-margin-top">
          <ion-col size="3">
            <h3 class="report__small-subheader">
              {{ "REPORT.BUILDING" | translate }}
            </h3>
          </ion-col>
          <ion-col size="9">
            {{ reportServ.report.building?.name }}
          </ion-col>
          <ion-col size="3">
            <h3 class="report__small-subheader">
              {{ "REPORT.FLOOR" | translate }}
            </h3>
          </ion-col>
          <ion-col size="9" [ngClass]="{ italic: !floorName }">
            <ng-container *ngIf="floorName">
              {{ floorName }}
            </ng-container>
            <ng-container *ngIf="!floorName">
              {{ "REPORT.NOT_ASSIGNED" | translate }}
            </ng-container>
          </ion-col>
          <ng-container *ngIf="dictionaryServ.dictionary.length > 0">
            <ion-col size="3">
              <h3 class="report__small-subheader">
                {{ "REPORT.CATEGORY" | translate }}
              </h3>
            </ion-col>
            <ion-col size="9">
              {{
                dictionaryServ.valueName(
                  dictionaryServ.reportTypeValues,
                  reportServ.report.type
                )
              }}
            </ion-col>
          </ng-container>
        </ion-row>
        <ion-row>
          <ion-col size="12">
            <div class="report__separator"></div>
          </ion-col>
        </ion-row>
        <ion-row *ngIf="statusVisable" class="padding-bottom ion-padding-top">
          <ion-col>
            <h3 class="report__small-subheader">
              {{ "REPORT.STATUS" | translate }}
            </h3>

            <app-select-buttons
              *ngIf="showStatusButtons"
              [disableValueZero]="true"
              [keyValueList]="dictionaryServ.reportStatusValues"
              [selectedValue]="reportServ.report.status"
              [confirmChange]="true"
              [disabled]="statusChangeDisabled"
              [disableDeselect]="true"
              icon="flag"
              [customMessage]="
                translateService.instant('REPORT.STATUS_CONFIRM_MESSAGE')
              "
              [outline]="true"
              (selectedChange)="selectedStatusChange($event)"
            >
            </app-select-buttons>
          </ion-col>
        </ion-row>

        <ion-row
          *ngIf="priorytetEnabledToChange"
          class="padding-bottom ion-padding-top"
        >
          <ion-col>
            <h3 class="report__small-subheader">
              {{ "REPORT.PRIORITY" | translate }}
            </h3>
            <app-select-buttons
              [keyValueList]="dictionaryServ.reportPriorityValues"
              [selectedValue]="reportServ.report.priority"
              [confirmChange]="true"
              (selectedChange)="selectedPriorityChange($event)"
              [disabled]="false"
              [outline]="true"
              icon="circle"
              [disableDeselect]="true"
              [customMessage]="
                translateService.instant('REPORT.PRIORITY_CONFIRM_MESSAGE')
              "
            >
            </app-select-buttons>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </ion-card-content>
</ion-card>
<ng-template #loader>
  <app-loading-sti></app-loading-sti>
</ng-template>
